import { makeActionCreator } from '../../config/store/utils'
import { onFetchDataTrucks, onFetchDataTrucksSuccess, onFetchDataTrucksError } from '../FuelLevel/FuelLevel.actions'
import { batch } from 'react-redux'
import { reloadDone } from '../../store/actions/screenActions'
import { getServicesStateAWS } from '../../services/fuelLevelService'

export const SET_MISSING_TIME_SUCCESS = 'SET_MISSING_TIME_SUCCESS'
export const onSetMissingTimeSuccess = makeActionCreator(SET_MISSING_TIME_SUCCESS, 'payload')

export const onWsDataTrucksThunk = wsTrucks => async dispatch => {
  dispatch(onFetchDataTrucks())

  try {
    const trucks = wsTrucks
    const lowLevelGas = wsTrucks.filter(truck => truck.percent < 20)
    const posibleError = lowLevelGas.length > 300

    return batch(() => {
      dispatch(
        onFetchDataTrucksSuccess({
          trucks,
          posibleError
        })
      )
      dispatch(reloadDone())
    })
  } catch (error) {
    return dispatch(onFetchDataTrucksError({ error }))
  }
}

export const GET_ORPAK_LATEST = 'GET_ORPAK_LATEST'
export const GET_ORPAK_LATEST_ERROR = 'GET_ORPAK_LATEST_ERROR'
export const GET_ORPAK_LATEST_SUCCESS = 'GET_ORPAK_LATEST_SUCCESS'
export const onGetOrpakLatest = makeActionCreator(GET_ORPAK_LATEST)
export const onGetOrpakLatestError = makeActionCreator(GET_ORPAK_LATEST_ERROR, 'payload')
export const onGetOrpakLatestSuccess = makeActionCreator(GET_ORPAK_LATEST_SUCCESS, 'payload')
export const onGetOrpakLatestThunk = (orpak, tankLevelsMean, weeklyTankMean, dayTurn, nightTurn) => async (
  dispatch,
  getState
) => {
  dispatch(onGetOrpakLatest())

  try {
    const orpakData = orpak.map(item => {
      const {
        equipo: camion,
        Fecha: fecha,
        FInicio: fechaInicio,
        FFin: fechaFin,
        cantidad: cantidadAbastecida,
        Capacidad: capacidad,
        Diff: diferencia
      } = item
      const cumplimiento = ((diferencia / capacidad) * 100).toFixed(2)
      const limSup = Math.round(capacidad * 0.8)
      const limInf = Math.round(capacidad * 0.7)
      const hora = fechaInicio.split(':')[0]
      let turno = ''
      if ((hora > 8) & (hora < 20)) {
        turno = 'A'
      } else {
        turno = 'B'
      }
      return {
        camion,
        fecha: new Date(fecha),
        fechaInicio,
        turno,
        fechaFin,
        cantidadAbastecida,
        capacidad,
        diferencia,
        cumplimiento,
        limSup,
        limInf
      }
    })

    const levelsMean = tankLevelsMean
    const weeklyTank = weeklyTankMean
    return batch(() => {
      dispatch(
        onGetOrpakLatestSuccess({
          orpakData: {
            data: orpakData
          },
          levelsMean: levelsMean,
          weeklyTank: weeklyTank,
          dayTurn: dayTurn,
          nightTurn: nightTurn
        })
      )
    })
  } catch (error) {
    console.log(error)
    return dispatch(onGetOrpakLatestError({ error }))
  }
}

export const GET_FUEL_SOURCE_COMPARISON = 'GET_FUEL_SOURCE_COMPARISON'
export const GET_FUEL_SOURCE_COMPARISON_ERROR = 'GET_FUEL_SOURCE_COMPARISON_ERROR'
export const GET_FUEL_SOURCE_COMPARISON_SUCCESS = 'GET_FUEL_SOURCE_COMPARISON_SUCCESS'
export const onGetFuelSourceComparison = makeActionCreator(GET_FUEL_SOURCE_COMPARISON)
export const onGetFuelSourceComparisonError = makeActionCreator(GET_FUEL_SOURCE_COMPARISON_ERROR, 'payload')
export const onGetFuelSourceComparisonSuccess = makeActionCreator(GET_FUEL_SOURCE_COMPARISON_SUCCESS, 'payload')

// The backend claims to already scope fuel_source_comparison to haul trucks (TR701-TR725),
// but it has leaked out-of-range equipment (e.g. TR733, TR740) before — filter defensively.
const isHaulTruckInScope = equipo => {
  const match = /^TR(\d+)$/.exec(equipo)
  if (!match) {
    return false
  }
  const equipmentNumber = Number(match[1])
  return equipmentNumber >= 701 && equipmentNumber <= 725
}

/**
 * Normalizes the websocket "fuel_source_comparison" payload: one row per fuel
 * load in the last 24h, tagged with its match state between dispatch and orpak.
 */
export const onGetFuelSourceComparisonThunk = value => async dispatch => {
  dispatch(onGetFuelSourceComparison())

  try {
    const rows = (Array.isArray(value) ? value : [])
      .filter(item => isHaulTruckInScope(item.equipo))
      .map(item => {
        const hasDispatch = item.ts_dispatch !== null && item.ts_dispatch !== undefined
        const hasOrpak = item.ts_orpak !== null && item.ts_orpak !== undefined

        let estado = 'solo_dispatch'
        if (hasDispatch && hasOrpak) {
          estado = 'matcheada'
        } else if (!hasDispatch && hasOrpak) {
          estado = 'solo_orpak'
        }

        return {
          equipo: item.equipo,
          tsDispatch: item.ts_dispatch,
          litrosDispatch: item.litros_dispatch,
          tsOrpak: item.ts_orpak,
          litrosOrpak: item.litros_orpak,
          diffLitros: item.diff_litros,
          pctDiff: item.pct_diff,
          // % remaining fuel when the truck arrived to load (0.0 - 100.0)
          nivelEstanque: item.nivel_estanque ?? null,
          // % the model estimated before loading; null when no ADS snapshot in the previous 30 min
          prediccionPct: item.prediccion_pct ?? null,
          // 0 = full load, 1 = partial load; null when no ADS snapshot in the following 20 min
          cargaParcial: item.carga_parcial ?? null,
          // Minestar's (competitor FMS) pre-load remaining fuel snapshot, in liters; null when it has no data
          remanenteMinestar: item.remanente_minestar ?? null,
          // who estimated closer to the real pre-load level: 'modelo' | 'minestar' | 'igual' | null
          masCercano: item.mas_cercano ?? null,
          estado
        }
      })

    return dispatch(onGetFuelSourceComparisonSuccess({ data: rows }))
  } catch (error) {
    console.log(error)
    return dispatch(onGetFuelSourceComparisonError({ error }))
  }
}

export const GET_SERVER_STATUS_SUCCESS = 'GET_SERVER_STATUS_SUCCESS'
export const onGetServerStatusSuccess = makeActionCreator(GET_SERVER_STATUS_SUCCESS, 'payload')

/**
 * Refreshes the service health badge (ESTADO: OPERACIONAL/DEGRADADO/INTERRUPCIÓN TOTAL).
 * Called once on mount and again on every "full message" (trucks array) from the
 * websocket, so it tracks whatever the real push cadence is instead of a guessed timer.
 */
export const onGetServerStatusThunk = () => async dispatch => {
  try {
    const status = await getServicesStateAWS()
    if (!status) {
      return null
    }
    return dispatch(onGetServerStatusSuccess({ health: status.health, sources: status.sources }))
  } catch (error) {
    console.log('onGetServerStatusThunk failed:', error)
    return null
  }
}
